import React, { useState } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { BiographySection } from './components/BiographySection';
import { PhilosophySection } from './components/PhilosophySection';
import { ModernRelevanceSection } from './components/ModernRelevanceSection';
import { FundSection } from './components/FundSection';
import { Footer } from './components/Footer';
import { SupportModal } from './components/SupportModal';
export function App() {
  const [supportModalOpen, setSupportModalOpen] = useState(false);
  return <div className="min-h-screen bg-[#F5F0E8] text-[#1A1A1A] font-sans selection:bg-[#B8860B]/30 selection:text-[#1A1A1A]" data-id="element-0">
      <Navbar onSupportClick={() => setSupportModalOpen(true)} data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <BiographySection data-id="element-4" />
        <PhilosophySection data-id="element-5" />
        <ModernRelevanceSection data-id="element-6" />
        <FundSection data-id="element-7" />
      </main>
      <Footer data-id="element-8" />

      <SupportModal isOpen={supportModalOpen} onClose={() => setSupportModalOpen(false)} data-id="element-9" />
    </div>;
}